import { INFTParams, IPaginationResponse, ITokenData } from 'types';
import { API } from 'api/API';
import { appConfig } from 'config';

export function getNFTs(params: INFTParams): Promise<IPaginationResponse<ITokenData>> {
  return API.get<IPaginationResponse<ITokenData>>(`${appConfig.apiUrl}/nft`, { params }).then(
    (response) => response.data,
  );
}
